import { createActions, createReducer } from "reduxsauce";
import { urls, getURL } from "../../api/urls";
import { apiConfig } from "../../api/config";
import { IReports, IParams, createReports } from "../dataMap/report";

/**Actions and types definitions **/
export const { Types, Creators } = createActions({
  fetchReportsRequest: ["keywords"],
  fetchReportsSuccess: ["reports", "params"],
  fetchReportsFailure: ["error"],
  setHighlightWord: ["highlightword"],
  setHighlightWordRequest: ["highlightword"],
  resetReportsRequest: null,
  fetchMoreReportsRequest: ["keywords"],
  fetchMoreReportsSuccess: ["reports", "params"],
  setFilterParams: ["params"],
});

interface IReportState {
  loading: boolean;
  reports: IReports;
  error: string;
  highlightword: string;
  keywords: string;
  loadingMore: boolean;
  filterParams: IParams;
}

const INITIAL_STATE: IReportState = {
  loading: false,
  reports: {
    reports: [],
    hasMorePages: false,
  },
  error: "",
  highlightword: "",
  keywords: "",
  loadingMore: false,
  filterParams: {
    keywords: "",
    regions: "",
    startdate: "",
    enddate: "",
    page: 1,
    pagesize: 6,
  },
};

export const request = (
  state = INITIAL_STATE,
  action: { keywords: string }
): IReportState => {
  return {
    ...state,
    loading: true,
    keywords: action.keywords,
  };
};

export const moreRequest = (
  state = INITIAL_STATE,
  action: { keywords: string }
): IReportState => {
  return {
    ...state,
    loadingMore: true,
    keywords: action.keywords,
  };
};
export const success = (
  state = INITIAL_STATE,
  action: { reports: IReports; params: any }
): IReportState => {
  return {
    ...state,
    loading: false,
    reports: action.reports,
    keywords: action.params.keywords,
    filterParams: action.params,
    error: "",
  };
};
export const failure = (
  state = INITIAL_STATE,
  action: { error: string }
): IReportState => {
  return {
    ...state,
    loading: false,
    reports: state.reports,
    error: action.error,
  };
};
export const reset = (state = INITIAL_STATE): IReportState => {
  return {
    ...INITIAL_STATE,
    reports: {
      reports: [],
      hasMorePages: false,
    },
    keywords: "",
  };
};
export const setHighlightword = (
  state = INITIAL_STATE,
  action: { highlightword: string }
): IReportState => {
  return {
    ...state,
    loading: false,
    highlightword: action.highlightword,
  };
};
export const fetchMore = (
  state = INITIAL_STATE,
  action: { reports: IReports; params: IParams }
): IReportState => {
  let reportsData = {
    ...state.reports,
    hasMorePages: action.reports.hasMorePages,
    reports: state.reports.reports.concat(action.reports.reports),
  };
  return {
    ...state,
    loadingMore: false,
    reports: reportsData,
    error: "",
    filterParams: action.params,
  };
};

export const newFilter = (
  state = INITIAL_STATE,
  action: { params: IParams }
): IReportState => {
  return { ...state, filterParams: { ...action.params } };
};

export const HANDLERS = {
  [Types.FETCH_REPORTS_REQUEST]: request,
  [Types.FETCH_REPORTS_SUCCESS]: success,
  [Types.FETCH_REPORTS_FAILURE]: failure,
  [Types.FETCH_MORE_REPORTS_REQUEST]: moreRequest,
  [Types.FETCH_MORE_REPORTS_SUCCESS]: fetchMore,
  [Types.SET_HIGHLIGHT_WORD]: setHighlightword,
  [Types.RESET_REPORTS_REQUEST]: reset,
  [Types.SET_FILTER_PARAMS]: newFilter,
};
export default createReducer(INITIAL_STATE, HANDLERS);

export const Actions = {
  ...Creators,

  resetReports: (dispatch) => {
    dispatch(Creators.resetReportsRequest());
  },

  fetchReports: (dispatch, params: IParams) => {
    const url = getURL(urls.REPORTS, params);
    dispatch(Creators.fetchReportsRequest(params.keywords));
    apiConfig
      .get(`${url}`)
      .then(async (response) => {
        const reports = createReports(response.data);
        dispatch(Creators.fetchReportsSuccess(reports, params));
      })

      .catch((error) => {
        dispatch(Creators.fetchReportsFailure(error.message));
      });
  },

  fetchMoreReports: (dispatch, params: IParams) => {
    params.page += 1;
    const url = getURL(urls.REPORTS, params);
    dispatch(Creators.fetchMoreReportsRequest(params.keywords));
    apiConfig
      .get(`${url}`)
      .then(async (response) => {
        const reports = createReports(response.data);
        dispatch(Creators.fetchMoreReportsSuccess(reports, params));
      })
      .catch((error) => {
        dispatch(Creators.fetchReportsFailure(error.message));
      });
  },
};
